export const ElementType = {
  video: 'video',
  link: 'link',
  orderedList: 'orderedList',
  unorderedList: 'unorderedList',
  h2: 'h2',
  color: 'color'
};
